(function () {
  'use strict';
  if (window.__hxFx) return; window.__hxFx = 1;
  document.documentElement.classList.add('hx-js');
  var H = '.hx-h2,.hx-title,.hx-blk__h,.hx-eyebrow,.hx-feat__t,.hx-uc__t,h1,h2,h3';
  var T = '.hx-sub,.hx-subtitle,.hx-prob__text,.hx-gu__txt,.hx-cta__txt,.hx-acc__body,.hx-benefits li,.hx-prob__list li,.hx-price,.hx-rating,.hx-tag,.hx-cutoff,.hx-delivery,.hx-buy__sub,.hx-gu__pts li,p';
  var I = '.hx-feat__card,.hx-uc__card,.hx-rcard,.hx-rf__card,.hx-offer,.hx-pw__tile,.hx-sp__slide,.hx-trust__item,.hx-acc,.hx-cmp tbody tr,.hx-ugc__item,.hx-fbt,.hx-imgblk,.hx-prob__media,.hx-cta__media,.hx-gu__seal,.hx-mini,.hx-feat__media';
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  function split(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n, i = 0;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      if (!t.nodeValue.trim()) return;
      var frag = document.createDocumentFragment();
      t.nodeValue.split(/(\s+)/).forEach(function (w) {
        if (!w) return;
        if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
        var s = document.createElement('span'); s.className = 'hx-w'; s.textContent = w;
        s.style.setProperty('--wd', (i++ * 70) + 'ms'); frag.appendChild(s);
      });
      t.parentNode.replaceChild(frag, t);
    });
  }
  function mark(el, type, delay) {
    if (el.__hxa || el.closest('template')) return; el.__hxa = 1;
    if (type === 'words') split(el);
    el.classList.add('hx-a', 'hx-a--' + type);
    el.style.setProperty('--hx-ad', delay + 'ms');
    if (io) io.observe(el); else el.classList.add('is-in');
  }
  function init(root) {
    var list = Array.prototype.slice.call((root || document).querySelectorAll('style[data-hx-fx]')).reverse();
    list.forEach(function (st) {
      var r = st.nextElementSibling; if (!r) return;
      var ah = st.getAttribute('data-ah'), at = st.getAttribute('data-at'), ai = st.getAttribute('data-ai');
      if (ai && ai !== 'none') r.querySelectorAll(I).forEach(function (el, i) { mark(el, ai, (i % 8) * 90); });
      if (ah && ah !== 'none') { if (r.matches(H)) mark(r, ah, 0); r.querySelectorAll(H).forEach(function (el) { mark(el, ah, 0); }); }
      if (at && at !== 'none') r.querySelectorAll(T).forEach(function (el) { mark(el, at === 'words' ? 'fade-up' : at, 120); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
